// removed by extract-text-webpack-plugin
module.exports = {"container":"documents-container__container___Mde0R"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/documents-container.scss
// module id = 1323
// module chunks = 0